// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"OJ-z","loadingMedia":"PJ-z","reviewsImagesAndVideos":"QJ-z","limitHeight":"RJ-z"};